import React from 'react';
import PropTypes from 'prop-types';
import { Masks, Sum, C, T } from 'shared/helpers';

import Styles from './Etapa.module.scss';

export default function Etapa({ etapa, produtos, tableKey, etapaIndex }) {
  const {
    Etapa,
    Fenologica,
    Aplicacao,
    Produtos,
    N,
    P2O5,
    K2O,
    Qtde,
    Total,
  } = Styles;

  let rowCount = 0;
  const k = () => `${tableKey}${++rowCount}`;

  const { number } = Masks;

  const map = T(produtos, []).reduce(
    (r, p) => ({
      ...r,
      [p.id]: [
        [
          T(p) && !Number(T(p).quantidade),
          Styles.Warning,
        ],
        [p && !Number(p.valor), Styles.Error],
      ],
    }),
    {},
  );

  return (
    <div className={Etapa}>
      <div className={Fenologica}>
        <p id={`etapa_${etapaIndex}_fenologica`}>{etapa.fenologica}</p>
      </div>
      <div className={Aplicacao}>
        <p id={`etapa_${etapaIndex}_aplicacao`}>{etapa.aplicacao}</p>
      </div>
      <div className={Produtos}>
        {produtos.map((produto, produtoIndex) => (
          <div key={k()} className={C(...map[produto.id])}>
            <p id={`etapa_${etapaIndex}_produto_${produtoIndex}`}>
              {produto.nome}
            </p>
          </div>
        ))}
        <div className={Total}>
          <p>Total de Nutrientes</p>
        </div>
        <div className={Total}>
          <p>Relação NPK</p>
        </div>
      </div>
      <div className={N}>
        {produtos.map((produto, produtoIndex) => (
          <div key={k()} className={C(...map[produto.id])}>
            <p id={`etapa_${etapaIndex}_produto_${produtoIndex}_N`}>
              {number(produto.N) + '%'}
            </p>
          </div>
        ))}
        <div className={Total}>
          <p>X</p>
        </div>
        <div className={Total}>
          <p>XXX</p>
        </div>
      </div>
      <div className={P2O5}>
        {produtos.map((produto, produtoIndex) => (
          <div
            key={k()}
            id={`etapa_${etapaIndex}_produto_${produtoIndex}_P205`}
            className={C(...map[produto.id])}
          >
            <p>{number(produto.P2O5) + '%'}</p>
          </div>
        ))}
        <div className={Total}>
          <p>X</p>
        </div>
        <div className={Total}>
          <p>XXX</p>
        </div>
      </div>
      <div className={K2O}>
        {produtos.map((produto, produtoIndex) => (
          <div
            key={k()}
            id={`etapa_${etapaIndex}_produto_${produtoIndex}_K2O`}
            className={C(...map[produto.id])}
          >
            <p>{number(produto.K2O) + '%'}</p>
          </div>
        ))}
        <div className={Total}>
          <p>X</p>
        </div>
        <div className={Total}>
          <p>XXX</p>
        </div>
      </div>
      <div className={Qtde}>
        {produtos.map((produto, produtoIndex) => (
          <div
            key={k()}
            id={`etapa_${etapaIndex}_produto_${produtoIndex}_quantidade`}
            className={C(...map[produto.id])}
          >
            <p>{number(produto.quantidade || 0)}</p>
          </div>
        ))}
        <div className={Total}>
          <p id={`etapa_${etapaIndex}_produto_quant_total`}>
            {number(Sum(produtos.map((produto) => produto.quantidade)))}
          </p>
        </div>
        <div className={Total}>
          <p>XXX</p>
        </div>
      </div>
    </div>
  );
}

Etapa.defaultProps = {};

Etapa.propTypes = {
  etapa: PropTypes.any.isRequired,
  produtos: PropTypes.any.isRequired,
  tableKey: PropTypes.string.isRequired,
  etapaIndex: PropTypes.number.isRequired,
};
